import React from 'react'
import ReactDOM from 'react-dom/client'
import { Auth0Provider, AppState } from '@auth0/auth0-react'

import './artworkBuilderEnv' // Must be imported before App
import './index.css'

import App from './App'

import * as serviceWorker from './serviceWorker'

const script = document.createElement('script')
script.src = 'newrelic.js'
script.async = true
document.head.appendChild(script)

const getCookie = (name: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}

const urlLogin = getCookie('urlLogin')

const mismatch = getCookie('mismatch')

const effectiveSearch =
  mismatch === 'true' && urlLogin
    ? `${urlLogin}`
    : window.location.search

const urlParams = new URLSearchParams(effectiveSearch)

type CustomAppState = AppState & {
  redirectPath?: string,
}

const handleRedirect = (appState: CustomAppState) => {
  const { redirectPath, userName } = appState || {}

  const { pathname } = window.location

  const newPathname = redirectPath ? `${pathname}${redirectPath}` : pathname

  if (userName) {
    document.cookie = `authenticatedUser=${userName}; path=/; max-age=86400` // 1 day
  }
    //Clear conditional cookie
    document.cookie = 'urlLogin=; path=/; max-age=0'
    document.cookie = 'mismatch=; path=/; max-age=0'
    
  window.history.replaceState(
    {},
    document.title,
    newPathname,
  )

  // Have to change path again to trigger refresh...
  // Hopefully this is fixed when react-router is updated.
  window.location.pathname = '/'
}

const domNode = document.getElementById('root')
const root = ReactDOM.createRoot(domNode)

root.render(
  <React.StrictMode>
    <Auth0Provider
      application={process.env.REACT_APP_APPLICATION_NAME}
      audience={process.env.REACT_APP_AUTH0_API_AUDIENCE}
      cacheLocation="localstorage"
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID || ''}
      domain={process.env.REACT_APP_AUTH0_DOMAIN || ''}
      onRedirectCallback={(appState: AppState) => handleRedirect(appState)}
      otpToken={urlParams.get('otpToken')}
      redirectUri={window.location.origin}
      useRefreshTokens
      username={urlParams.get('username')}
      advancedOptions={{
        defaultScope: process.env.REACT_APP_AUTH0_SCOPE,
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
